'use client'

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import type { ComponentProps } from 'react'
import { cn } from '@/src/utils/styles'

const RadioButtonGroup = ({
  className,
  ref,
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Root>) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn('inline-flex bg-surface1 rounded-3xl p-1', className)}
      {...props}
      ref={ref}
    />
  )
}

RadioButtonGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioButtonGroupItem = ({
  className,
  ref,
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Item>) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'px-3 py-1 data-[state=checked]:bg-background data-[state=checked]:text-button-secondary-text hover:text-button-secondary-text-hover focus-outer transition-all rounded-full font-semibold text-tertiary text-sm',
        className,
      )}
      {...props}
    >
      {props.children}
    </RadioGroupPrimitive.Item>
  )
}

RadioButtonGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioButtonGroup, RadioButtonGroupItem }
